export const actionAlert = {
  ADD: 'ADD',
  ADD_NO_SETTIMEOUT: 'ADD_NO_SETTIMEOUT',
  REMOVE: 'REMOVE',
  INITANIMATIONS: 'INITANIMATIONS'
};
